import React from 'react';
import { Link } from 'react-router-dom';

export const Footer: React.FC = () => {
  return (
    <footer style={{ backgroundColor: '#121212', borderTop: '1px solid rgba(255, 255, 255, 0.08)', padding: '80px 20px 0', position: 'relative', overflow: 'hidden' }}>
      <div className="container">
        
        {/* Main Footer Grid */}
        <div 
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))',
            gap: '40px',
            marginBottom: '64px'
          }}
          className="micro1-footer-grid"
        >
          {/* Brand Column */}
          <div style={{ gridColumn: 'span 1' }}>
            <Link to="/" style={{ textDecoration: 'none' }}>
              <span style={{ 
                fontFamily: "'Outfit', sans-serif", 
                fontSize: '22px', 
                fontWeight: 600, 
                color: '#FFFFFF',
                letterSpacing: '-0.5px'
              }}>
                draway<span style={{ color: '#6D7CFF' }}>.</span>
              </span>
            </Link>
            <p style={{ fontSize: '13px', color: '#9CA3AF', marginTop: '12px', lineHeight: 1.6, maxWidth: '220px' }}>
              Enterprise-grade identity &amp; passkey infrastructure.
            </p>
            <div style={{ display: 'flex', gap: '12px', marginTop: '16px', color: '#9CA3AF' }}>
              <a href="https://twitter.com" target="_blank" rel="noreferrer" style={{ color: '#9CA3AF', fontSize: '14px' }}>𝕏</a>
              <a href="https://linkedin.com" target="_blank" rel="noreferrer" style={{ color: '#9CA3AF', fontSize: '14px' }}>in</a>
              <a href="https://github.com" target="_blank" rel="noreferrer" style={{ color: '#9CA3AF', fontSize: '14px' }}>gh</a>
            </div>
          </div>

          {/* Column 2: Platform */}
          <div>
            <div style={{ fontSize: '12px', fontWeight: 500, color: '#FFFFFF', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: '16px' }}>
              Platform
            </div>
            <ul style={{ listStyle: 'none', display: 'flex', flexDirection: 'column', gap: '10px', padding: 0, margin: 0 }}>
              <li><Link to="/docs#passkeys" style={{ fontSize: '13px', color: '#9CA3AF' }}>Passkeys &amp; FIDO2</Link></li>
              <li><Link to="/docs#whatsapp" style={{ fontSize: '13px', color: '#9CA3AF' }}>WhatsApp &amp; SMS OTP</Link></li>
              <li><Link to="/compare#fraud-shield" style={{ fontSize: '13px', color: '#9CA3AF' }}>Toll-Fraud Shield</Link></li>
              <li><Link to="/docs#tenancy" style={{ fontSize: '13px', color: '#9CA3AF' }}>Multi-Tenant Domains</Link></li>
              <li><Link to="/pricing" style={{ fontSize: '13px', color: '#9CA3AF' }}>Enterprise SAML SSO</Link></li>
            </ul>
          </div>

          {/* Column 3: Developers */}
          <div>
            <div style={{ fontSize: '12px', fontWeight: 500, color: '#FFFFFF', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: '16px' }}>
              Developers
            </div>
            <ul style={{ listStyle: 'none', display: 'flex', flexDirection: 'column', gap: '10px', padding: 0, margin: 0 }}>
              <li><Link to="/docs" style={{ fontSize: '13px', color: '#9CA3AF' }}>Documentation</Link></li>
              <li><Link to="/docs#sdk" style={{ fontSize: '13px', color: '#9CA3AF' }}>TypeScript SDK</Link></li>
              <li><Link to="/docs#api" style={{ fontSize: '13px', color: '#9CA3AF' }}>REST API Specs</Link></li>
              <li><Link to="/waitlist" style={{ fontSize: '13px', color: '#9CA3AF' }}>Sandbox API Keys</Link></li>
              <li><Link to="/compare" style={{ fontSize: '13px', color: '#9CA3AF' }}>Why Draway</Link></li>
            </ul>
          </div>

          {/* Column 4: Security & Architecture */}
          <div>
            <div style={{ fontSize: '12px', fontWeight: 500, color: '#FFFFFF', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: '16px' }}>
              Security
            </div>
            <ul style={{ listStyle: 'none', display: 'flex', flexDirection: 'column', gap: '10px', padding: 0, margin: 0 }}>
              <li><Link to="/security#argon2" style={{ fontSize: '13px', color: '#9CA3AF' }}>Argon2id Vault</Link></li>
              <li><Link to="/security#aes" style={{ fontSize: '13px', color: '#9CA3AF' }}>AES-256-GCM State</Link></li>
              <li><Link to="/security#lockout" style={{ fontSize: '13px', color: '#9CA3AF' }}>15m Lockout Defense</Link></li>
              <li><Link to="/terms#sla" style={{ fontSize: '13px', color: '#9CA3AF' }}>99.99% Edge SLA</Link></li>
              <li><Link to="/security#compliance" style={{ fontSize: '13px', color: '#9CA3AF' }}>SOC2 Readiness</Link></li>
            </ul>
          </div>

          {/* Column 5: Company & Legal */}
          <div>
            <div style={{ fontSize: '12px', fontWeight: 500, color: '#FFFFFF', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: '16px' }}>
              Legal
            </div>
            <ul style={{ listStyle: 'none', display: 'flex', flexDirection: 'column', gap: '10px', padding: 0, margin: 0 }}>
              <li><Link to="/terms" style={{ fontSize: '13px', color: '#9CA3AF' }}>Terms of Service</Link></li>
              <li><Link to="/privacy" style={{ fontSize: '13px', color: '#9CA3AF' }}>Privacy Policy</Link></li>
              <li><Link to="/dpa" style={{ fontSize: '13px', color: '#9CA3AF' }}>Data Processing (DPA)</Link></li>
              <li><Link to="/cookies" style={{ fontSize: '13px', color: '#9CA3AF' }}>Cookie Policy</Link></li>
              <li><a href="https://draway.in" target="_blank" rel="noreferrer" style={{ fontSize: '13px', color: '#9CA3AF' }}>draway.in ↗</a></li>
            </ul>
          </div>
        </div>

        {/* Bottom Line */}
        <div 
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            paddingTop: '24px',
            paddingBottom: '24px',
            borderTop: '1px solid rgba(255, 255, 255, 0.08)',
            fontSize: '12px',
            color: '#6B7280',
            flexWrap: 'wrap',
            gap: '12px'
          }}
        >
          <div>© 2026 Draway Technologies Inc. All rights reserved.</div>
          <div style={{ display: 'flex', gap: '16px', flexWrap: 'wrap' }}>
            <Link to="/terms" style={{ color: '#9CA3AF' }}>Legal Center</Link>
            <Link to="/privacy" style={{ color: '#9CA3AF' }}>Privacy Policy</Link>
            <Link to="/cookies" style={{ color: '#9CA3AF' }}>Cookie Policy</Link>
          </div>
        </div>

        {/* Giant micro1 Style Watermark at Bottom */}
        <div 
          style={{
            textAlign: 'center',
            marginTop: '32px',
            marginBottom: '-28px',
            overflow: 'hidden',
            userSelect: 'none',
            pointerEvents: 'none'
          }}
          aria-hidden="true"
        >
          <span 
            style={{
              fontFamily: "'Outfit', sans-serif",
              fontSize: 'clamp(64px, 18vw, 240px)',
              fontWeight: 700,
              color: 'rgba(255, 255, 255, 0.035)',
              letterSpacing: 'clamp(-5px, -1vw, -2px)',
              lineHeight: 0.8,
              display: 'inline-block',
              maxWidth: '100%'
            }}
          >
            draway
          </span>
        </div>

      </div>
    </footer>
  );
};

export default Footer;
